export default __webpack_public_path__ + "static/media/book8.ec6fa6d0.jpg";